import { CredentialType } from "@api/shared-runtime/enums";
import { asDetails } from "../components/credential-card/credential-details/detail-values";
import type { Credential } from "../types";

function specialtyCodes(value: unknown): string[] {
  if (!Array.isArray(value)) {
    return [];
  }
  return [
    ...new Set(
      value.flatMap((code) => {
        if (typeof code !== "string") {
          return [];
        }
        const normalized = code.trim();
        return normalized ? [normalized] : [];
      }),
    ),
  ];
}

/** An explicit provider selection, including clearing every selection, takes
 * precedence over imported NPI taxonomy. Only an absent selection falls back. */
export function getProviderSpecialtyCodes(credentials: Credential[]): string[] {
  const personalInfo = credentials.find(
    (credential) =>
      credential.present &&
      credential.credentialType === CredentialType.PersonalInfo,
  );
  const professional = asDetails(
    asDetails(personalInfo?.version?.details).professional,
  );
  if (Array.isArray(professional.specialtyCodes)) {
    return specialtyCodes(professional.specialtyCodes);
  }
  const npi = credentials.find(
    (credential) =>
      credential.present && credential.credentialType === CredentialType.Npi,
  );
  return specialtyCodes(asDetails(npi?.version?.details).taxonomyCodes);
}
